import asideSummary from "../aside-summary";

const modAsideSummary = new asideSummary();

export default class boxArena{

    store(
        box_arena: HTMLElement | null,
        arena: any,
        player_available: string,
        arena_full: boolean,
        price: any,
    ){

        // Places available
        const places_available = document.querySelector('#places-available') as HTMLSpanElement;
        const players_available = document.querySelector('#players-available') as HTMLSpanElement;

        // Input shared arena
        const input_shared_arena = document.querySelector('#field_type_arena_1') as HTMLInputElement;
        const label_shared_arena: HTMLLabelElement | null = document.querySelector('#label_type_arena_1');
        const price_arena_shared = document.querySelector('#price_arena_shared') as HTMLSpanElement;

        // Input full arena
        const input_full_arena = document.querySelector('#field_type_arena_2') as HTMLInputElement;
        const label_full_arena: HTMLLabelElement | null = document.querySelector('#label_type_arena_2');
        const price_arena_full = document.querySelector('#price_arena_full') as HTMLSpanElement;
        const field_arena = document.querySelector('#field_arena') as HTMLInputElement;

        // box arena
        box_arena?.classList.add('active');

        if(arena == null || arena.length == 0){
                
            // Places available
            places_available?.classList.remove('text-semantic-green-300');
            places_available?.classList.remove('text-neutral-200');
            places_available?.classList.add('text-semantic-red-300');

            if(players_available !== null){
                
                players_available.innerHTML = '0';
                
            }
            
            // Input shared arena
            input_shared_arena.checked = false;
            input_shared_arena.disabled = true;
            label_shared_arena?.classList.add('border-semantic-red-300');
            label_shared_arena?.classList.remove('border-neutral-700');

            // Input full arena
            input_full_arena.checked = false;
            input_full_arena.disabled = true;
            label_full_arena?.classList.add('border-semantic-red-300');
            label_full_arena?.classList.remove('border-neutral-700');

        }else{
            
            field_arena.value = arena;
            
            // Places available
            places_available?.classList.remove('text-semantic-red-300');
            places_available?.classList.remove('text-neutral-200');
            places_available?.classList.add('text-semantic-green-300');

            if(players_available !== null){
                
                players_available.innerHTML = player_available;
                
            }

            input_shared_arena.checked = true;
            input_shared_arena.disabled = false;

            label_shared_arena?.classList.remove('border-semantic-red-300');
            label_shared_arena?.classList.add('border-neutral-700');

            if(price_arena_shared !== null){
            
                price_arena_shared.innerHTML = price.shared.price_total;
                
            }
            
            if(arena_full == true){
                
                input_full_arena.disabled = false;
                label_full_arena?.classList.remove('border-semantic-red-300');
                label_full_arena?.classList.add('border-neutral-700');

                if(price_arena_full !== null){
            
                    price_arena_full.innerHTML = price.full.price_total;
                    
                }

            }else{
                
                input_full_arena.disabled = true;
                label_full_arena?.classList.remove('border-semantic-red-300');
                label_full_arena?.classList.add('border-neutral-700');

                if(price_arena_full !== null){
            
                    price_arena_full.innerHTML = '-';
                    
                }

            }

        }


    }

    /**
     * Reset box arena
     * @param box_arena 
     */
    reset(){
        
        const box_arena: HTMLElement | null = document.querySelector('#box-arena');
        
        box_arena?.classList.remove('active');

        // Places available
        const places_available = document.querySelector('#places-available') as HTMLSpanElement;
        const players_available = document.querySelector('#players-available') as HTMLSpanElement;

        // Input shared arena
        const input_shared_arena = document.querySelector('#field_type_arena_1') as HTMLInputElement;
        const label_shared_arena: HTMLLabelElement | null = document.querySelector('#label_type_arena_1');
        const price_arena_shared = document.querySelector('#price_arena_shared') as HTMLSpanElement;

        // Input full arena
        const input_full_arena = document.querySelector('#field_type_arena_2') as HTMLInputElement;
        const label_full_arena: HTMLLabelElement | null = document.querySelector('#label_type_arena_2');
        const price_arena_full = document.querySelector('#price_arena_full') as HTMLSpanElement;

        // Places available
        places_available?.classList.remove('text-semantic-green-300');
        places_available?.classList.remove('text-semantic-red-300');
        places_available?.classList.add('text-neutral-200');

        players_available.innerHTML = '-';

        input_shared_arena.checked = false;
        input_shared_arena.disabled = false;
        label_shared_arena?.classList.remove('border-semantic-red-300');
        label_shared_arena?.classList.add('border-neutral-700');

        if(price_arena_shared !== null){
            
            price_arena_shared.innerHTML = '-';
            
        }

        input_full_arena.checked = false;
        input_full_arena.disabled = true;
        label_full_arena?.classList.remove('border-semantic-red-300');
        label_full_arena?.classList.add('border-neutral-700');

        if(price_arena_full !== null){
            
            price_arena_full.innerHTML = '-';
            
        }

        modAsideSummary.setTypeArena();

    }

}